import { MapPin } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { GOOGLE_MAPS_QUERY, VENUE_ADDRESS } from "@/config/siteConfig";

export const LocationMap = () => (
  <section id="location" data-testid="location-map-section" className="bg-[#043927]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-12">
      <FadeIn>
        <p className="text-[#D4AF37] uppercase tracking-[0.4em] text-xs mb-5">Find Your Way</p>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <h2 className="font-serif-luxe text-4xl md:text-5xl font-medium text-[#FAF9F6] leading-tight">
            Visit <span className="italic text-[#F3E5AB]">Leelarav Greens</span>
          </h2>
          <p className="flex items-start gap-2 text-[#FAF9F6]/70 text-sm font-light max-w-md leading-relaxed">
            <MapPin size={18} className="text-[#D4AF37] shrink-0 mt-0.5" strokeWidth={1.5} />
            {VENUE_ADDRESS}
          </p>
        </div>
      </FadeIn>
    </div>

    <div className="relative w-full h-[440px] md:h-[520px] overflow-hidden border-y border-[#D4AF37]/25">
      <iframe
        data-testid="google-maps-iframe"
        title="LeelaRav Greens location map"
        src={`https://www.google.com/maps?q=${encodeURIComponent(GOOGLE_MAPS_QUERY)}&output=embed`}
        className="absolute inset-0 w-full h-full border-0"
        style={{ filter: "grayscale(0.85) contrast(1.05) brightness(0.94)" }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="absolute inset-0 pointer-events-none bg-[#043927]/15 mix-blend-multiply" />
      <div className="absolute inset-x-0 top-0 h-16 pointer-events-none bg-gradient-to-b from-[#043927]/60 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-16 pointer-events-none bg-gradient-to-t from-[#043927]/60 to-transparent" />
    </div>
  </section>
);
